import { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ReadMorePromotion } from "./model";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import promotionImage from "../assets/images/bet-frenzy/dummy-banner.jpg";
import arrowRight from "../assets/images/bet-frenzy/arrowRight.svg";
import arrowLeft from "../assets/images/bet-frenzy/arrowLeft.svg";
import { promotion } from "../redux/slices/promotions/promotionSlice";
import { toast } from "react-toastify";

export default function PromotionCarousel({
  type,
  setIsWalletOpen,
  setLoginOpen,
  setLoginMode,
  setSignupOpen,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [promotionsList, setPromotionsList] = useState([]);
  // const promotionData = useSelector((state) => state.promotion.data);
  const [promo, setPromo] = useState(null);

  const { data: profileData } = useSelector((state) => state.getProfile);
  const totalSlides = promotionsList?.length;
  useEffect(() => {
    if(profileData) {
      getList(); // fallback if Redux has no data

    }
  }, []);

  const getList = () => {
    dispatch(promotion())
      .unwrap()
      .then((res) => {
        setPromotionsList(res.data);
        toast.success(res.message);
      })
      .catch((error) => {
        console.error("Failed :", error);
        toast.warn(error.message);
      });
  };
  const settings = {
    infinite: false,
    speed: 300,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    afterChange: (index) => setCurrentSlide(index),
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  useEffect(() => {
    function updateSlidesToShow() {
      const width = window.innerWidth;
      if (width < 480) setSlidesToShow(1);
      else if (width < 768) setSlidesToShow(2);
      else if (width < 1024) setSlidesToShow(3);
      else if (width < 1200) setSlidesToShow(4);
      else setSlidesToShow(3);
    }
    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);
  const isLeftDisabled = currentSlide == 0;
  const isRightDisabled = currentSlide >= totalSlides - slidesToShow;
  const scroll = (direction) => {
    if (!sliderRef.current) return;
    if (direction == "left" && !isLeftDisabled) {
      sliderRef.current.slickPrev();
    }
    if (direction == "right" && !isRightDisabled) {
      sliderRef.current.slickNext();
    }
  };
  return (
    <>
      {promotionsList?.length > 0 && (
        <div className="carousel-container">
          <div
            className={`align-items-start d-flex flex-column flex-sm-column flex-md-column flex-lg-row carousel-header`}
          >
            <h4 className="fw-medium hero-heading text-capitalize color-CCD6F6 mt-3 mb-2 fs-20">
              Promotions
            </h4>
            <div className="mt-0 mt-xs-0 mt-sm-0 mt-md-0 mt-lg-3 mb-2 d-flex w-100 justify-content-between justify-content-sm-between justify-content-md-between justify-content-lg-end">
              <span
                className="see-all align-content-center cursor-pointer"
                onClick={() => navigate("promotion")}
              >
                See all{" "}
                <span className="ms-2 text-gray">
                  ({promotionsList?.length})
                </span>
              </span>
              <div className="d-flex">
                <span
                  className={`nav-btn-ft mx-1 left d-flex justify-content-center align-items-center ${
                    isLeftDisabled ? "disabled-arrow" : ""
                  }`}
                  onClick={() => scroll("left")}
                >
                  <img
                    src={arrowLeft}
                    width={15}
                    alt="Left"
                    style={{
                      filter: isLeftDisabled ? "grayscale(100%)" : "none",
                      cursor: isLeftDisabled ? "default" : "pointer",
                    }}
                    loading="lazy"
                  />
                </span>

                <span
                  className={`nav-btn-ft mx-1 right d-flex justify-content-center align-items-center ${
                    isRightDisabled ? "disabled-arrow" : ""
                  }`}
                  onClick={() => scroll("right")}
                >
                  <img
                    src={arrowRight}
                    width={15}
                    alt="Right"
                    style={{
                      filter: isRightDisabled ? "grayscale(100%)" : "none",
                      cursor: isRightDisabled ? "default" : "pointer",
                    }}
                    loading="lazy"
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="carousel-wrapper">
            <Slider
              ref={sliderRef}
              {...settings}
              className="promotion-carousel carousel-wrap-live casino-home-wrap-live promotion-carousel-custom"
            >
              {promotionsList?.map((item, idx) => (
                <div
                  className="game-card-promotion bg-gray text-white rounded-4"
                  key={idx}
                >
                  <img
                    draggable="false"
                    src={item?.promoBannerCardUrl || promotionImage}
                    alt=""
                    className="w-100"
                    loading="lazy"
                  />
                  <div className="pb-3">
                    <p className="fs-16 fw-bold text-partial-white text-center text-uppercase mt-4 mb-3">
                      {item?.title}
                    </p>
                    <p className="fs-13 text-partial-white text-center">
                      {item?.description}
                    </p>
                    <div className="d-flex justify-content-between mt-5 px-4 py-3">
                      <span
                        className="fs-12 text-partial-white text-decoration-underline cursor-pointer"
                        onClick={() => {
                          navigate("/promotion", { state: { promo: item } });
                          // setIsOpen(true);
                          // setPromo(item);
                        }}
                      >
                        Read More
                      </span>
                      <div className="app-navbar-item align-self-center">
                        {!profileData?.user ? (
                          <span
                            className="box-green-depo text-black text-white-btn fs-12 py-0 px-4 align-self-center cursor-pointer"
                            onClick={() => {
                              setLoginMode("signup");
                              setSignupOpen(true);
                            }}
                          >
                            Register
                          </span>
                        ) : (
                          item.minDeposit > 0 && (
                            <span
                              className="box-green-depo text-black text-white-btn fs-12 py-0 px-4 align-self-center cursor-pointer"
                              onClick={() => {
                                setIsWalletOpen(true);
                              }}
                            >
                              Deposit
                            </span>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
      <ReadMorePromotion
        open={isOpen}
        setOpen={setIsOpen}
        promo={promo}
        setLoginOpen={setLoginOpen}
        profileData={profileData}
        setLoginMode={setLoginMode}
        setSignupOpen={setSignupOpen}
      />
    </>
  );
}
